import { Outlet } from 'react-router-dom';
import Sidebar from './components/Sidebar/Sidebar';
import { Layout } from 'antd';
import Header from './components/Header';
const { Content } = Layout
export default function MainLayout({ isCollapsed, setIsCollapsed, onLogout }) {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} />
      <Layout>
        <Header
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
          onLogout={onLogout}
        />
        <Content style={{ margin: '16px 0' }}>
          <Outlet /> {/* Tất cả các route con sẽ render tại đây */}
        </Content>
      </Layout>
    </Layout>
  );
}
